"use client";

import { useShopConfig } from "~/hooks/useShopConfig";
import { useMemo } from "react";
import { useTranslations } from "~/hooks/useTranslations";
import { generatePath } from "~/lib/client/utils";
import { Paths } from "~/lib/Paths";
import { Banner } from "./Banner";

export function GiftcardInfoBanner(): JSX.Element {
  const {
    shopConfig: { giftcardOptions },
  } = useShopConfig();
  const t = useTranslations();

  const thumbnail = useMemo(() => {
    return giftcardOptions?.salesImage?.variants.reduce((prev, current) =>
      Number(prev?.width) > Number(current.width) ? prev : current,
    );
  }, [giftcardOptions]);

  return (
    <Banner
      title={t.giftcards.info_banner_title}
      description={t.giftcards.info_banner_description}
      buttonLabel={t.giftcards.info_banner_button}
      buttonLink={generatePath(Paths.GIFTCARDS)}
      image={{
        url: thumbnail?.url ?? "",
        dimensions: {
          width: thumbnail?.width ?? 0,
          height: thumbnail?.height ?? 0,
        },
      }}
    />
  );
}
